import React from 'react'
import { SvgIcon } from '../svg-icon'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.DefaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}
/**
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <WeatherAirFillIcon width={12} />
 */
export const WeatherAirFillIcon = props => (
    <SvgIcon {...props}>
        <path d="M23.25 40C21.45 40 20.025 39.5333 18.975 38.6C17.925 37.6667 17.4 36.25 17.4 34.35H20.8C20.8 35.2167 20.9917 35.875 21.375 36.325C21.7583 36.775 22.3833 37 23.25 37C24.15 37 24.7917 36.8 25.175 36.4C25.5583 36 25.75 35.3167 25.75 34.35C25.75 33.3833 25.5583 32.675 25.175 32.225C24.7917 31.775 24.15 31.55 23.25 31.55H4V28.55H23.25C25.05 28.55 26.4167 29.0167 27.35 29.95C28.2833 30.8833 28.75 32.35 28.75 34.35C28.75 36.25 28.2833 37.6667 27.35 38.6C26.4167 39.5333 25.05 40 23.25 40ZM4 19.6V16.6H31.4C32.6333 16.6 33.5333 16.3083 34.1 15.725C34.6667 15.1417 34.95 14.1667 34.95 12.8C34.95 11.4333 34.6667 10.4583 34.1 9.875C33.5333 9.29167 32.6333 9 31.4 9C30.1333 9 29.2167 9.34167 28.65 10.025C28.0833 10.7083 27.8 11.5667 27.8 12.6H24.8C24.8 10.6667 25.3833 9.08333 26.55 7.85C27.7167 6.61667 29.3333 6 31.4 6C33.4333 6 35.0333 6.59167 36.2 7.775C37.3667 8.95833 37.95 10.6333 37.95 12.8C37.95 14.9667 37.3667 16.6417 36.2 17.825C35.0333 19.0083 33.4333 19.6 31.4 19.6H4ZM37.6 36.1V33.1C38.7667 33.1 39.625 32.775 40.175 32.125C40.725 31.475 41 30.5333 41 29.3C41 28.0333 40.6917 27.1167 40.075 26.55C39.4583 25.9833 38.5667 25.7 37.4 25.7H4V22.7H37.4C39.4667 22.7 41.0833 23.2833 42.25 24.45C43.4167 25.6167 44 27.2333 44 29.3C44 31.4333 43.45 33.1 42.35 34.3C41.25 35.5 39.6667 36.1 37.6 36.1Z" />
    </SvgIcon>
)

WeatherAirFillIcon.defaultProps = defaultProps
